import { render, staticRenderFns } from "./CSATSettings.vue?vue&type=template&id=f5f932b8"
import script from "./CSATSettings.vue?vue&type=script&lang=js"
export * from "./CSATSettings.vue?vue&type=script&lang=js"
import style0 from "./CSATSettings.vue?vue&type=style&index=0&id=f5f932b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports